import axios from './api'

export const albumInfo = data => {
    return axios({
        url: '/v1/web/sound/info',
        method: 'post',
        data
    })
}
export const authorData = data => {
    return axios({
        url: '/v1/web/album/info',
        method: 'post',
        data
    })
}

export const soundList = data => {
    return axios({
        url: '/v1/web/album/sound/list',
        method: 'post',
        data
    })
}

export const getCallbackVersion = () => {
    return axios({
        url: '/app/callback/version',
        method: 'get',
    })
}
// 默认全部导出
export default {
    albumInfo,
    soundList,
    authorData,
    getCallbackVersion
}


// WEBPACK FOOTER //
// ./src/http/interface.js